import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ComunicadoService } from '../service/comunicado.service';
import { FileUploader } from 'ng2-file-upload';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { TipoEnvio, TipoEnvioLabels, TipoEnvioIcons } from '../enums/tipo-envio.enum';

declare var $: any;

@Component({
  selector: 'app-novo',
  templateUrl: './novo.component.html',
  styleUrls: ['./novo.component.css'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class NovoComponent implements OnInit, AfterViewInit {

  marcadores = [];
  arquivos: Blob[] = [];
  contatos = [];
  dealers = [];
  titulo = '';
  mensagem = '';
  tipoEnvio: TipoEnvio | null = null;
  countDestinatario: number = 0;
  countDealer: number = 0;
  habilitaEnvio = true;
  maxCaracteres = 998;
  selecionado: object;
  enviando = false;
  enviado = false;
  mostrarModalDestinatarios = false;
  mostrarModalDealers = false;
  mostrarAvisoAsciiTitulo = false;
  mostrarAvisoAsciiMensagem = false;
  
  // Limite de tamanho total de arquivos: 10MB
  readonly TAMANHO_MAX_TOTAL_BYTES = 10 * 1024 * 1024;
  tamanhoTotalArquivos = 0;
  
  TipoEnvio = TipoEnvio;
  TipoEnvioLabels = TipoEnvioLabels;
  TipoEnvioIcons = TipoEnvioIcons;

  tipoEnvioOpcoes: Array<{label: string, value: TipoEnvio, icon: string}> = [];
 
  public uploader: FileUploader = new FileUploader({
    isHTML5: true
  });

  private readonly CARACTERES_INVALIDOS_COMUNS = {
    'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
    'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
    'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
    'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
    'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'ç': 'c', 'ñ': 'n',
    'Á': 'A', 'À': 'A', 'Ã': 'A', 'Â': 'A', 'Ä': 'A',
    'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
    'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
    'Ó': 'O', 'Ò': 'O', 'Õ': 'O', 'Ô': 'O', 'Ö': 'O',
    'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
    'Ç': 'C', 'Ñ': 'N'
  };

  @ViewChild('fileinput') fileInput: ElementRef;

  @Input() ativo = false;
  @Output() salvado = new EventEmitter<boolean>();
  @Output() ativaComunicado = new EventEmitter<boolean>();


  constructor(private service: ComunicadoService, private toast: ToastrService, private translate: TranslateService) { }

  ngOnInit() {
    this.atualizarOpcoesDropdown();
    
    this.translate.onLangChange.subscribe(() => {
      this.atualizarOpcoesDropdown();
    });

    this.service.buscarContatos()
      .then(res => {
        this.contatos = res.dados;
        this.contatos = this.contatos.map(function(p) {
          const contato = p;
          const nomeOriginal = contato.nome;
          const emailContato = contato.email || '';
          
          contato.selecionado = false;
          
          // Adiciona email ao campo nome para permitir busca (o filtro busca em dealer.nome)
          if (emailContato) {
            contato.nome = `${nomeOriginal} ${emailContato}`;
          }
          
          // toTexto() exibe apenas o nome (sem email) no botão
          contato.toTexto = function() {
            return nomeOriginal;
          };
          
          // toDescricao() retorna o nome original
          contato.toDescricao = function() {
            return nomeOriginal;
          };
          
          
          return contato;
        });
      })

       this.service.buscarDealers()
      .then(res => {
        // /filtro/dealer devolve { filtros: [{ id, descricao }], rotulo }
        const lista = res.filtros || [];

        this.dealers = lista.map(function(p) {
          const dealer = p;
          const nomeOriginal = dealer.descricao;

          // app-filtro-dealers filtra por dealer.nome
          dealer.nome = nomeOriginal;
          dealer.selecionado = false;

          dealer.toTexto = function() {
            return nomeOriginal;
          };

          dealer.toDescricao = function() {
            return nomeOriginal;
          };

          return dealer;
        });
      })
      .catch(erro => {
        console.error('Erro ao carregar dealers:', erro);
      })
    
    this.uploader.onAfterAddingFile = (fileItem) => {
      const tamanhoAtual = this.calcularTamanhoTotal();
      
      if (tamanhoAtual > this.TAMANHO_MAX_TOTAL_BYTES) {
        const tamanhoArquivoMB = this.formatarTamanho(fileItem._file.size);
        const tamanhoDisponivelMB = this.formatarTamanho(this.TAMANHO_MAX_TOTAL_BYTES - (tamanhoAtual - fileItem._file.size));
        const limiteMB = this.formatarTamanho(this.TAMANHO_MAX_TOTAL_BYTES);
        
        this.uploader.removeFromQueue(fileItem);
        
        this.translate.get('comunicado.novaMensagem.erroTamanhoTotal', {
          arquivo: fileItem._file.name,
          tamanhoArquivo: tamanhoArquivoMB,
          tamanhoDisponivel: tamanhoDisponivelMB,
          limite: limiteMB
        }).subscribe(mensagem => {
          this.toast.error(mensagem, this.translate.instant('comunicado.erro.limiteExcedido'));
        });
        
        return;
      }
      
      this.tamanhoTotalArquivos = tamanhoAtual;

      this.sanitizarNomeArquivo(fileItem);
    };
  }

  ngAfterViewInit() {
  }

  contatosSelecionados(): any[] {
    return this.contatos.filter(p => p.selecionado);
  }

  contatosDisponiveis(): any[] {
    return this.contatos.filter(p => !p.selecionado);
  }

  dealersSelecionados(): any[] {
    return this.dealers.filter(p => p.selecionado);
  }

  dealersDisponiveis(): any[] {
    return this.dealers.filter(p => !p.selecionado);
  }

  salvarComunicado(): void {
    if (this.enviando) return;
    
    if (this.mensagem.length > this.maxCaracteres) {
      this.translate.get('comunicado.novaMensagem.avisoLimite').subscribe(text => {
        this.toast.warning(text, 'Atenção');
      });
      return;
    }
    
    if (this.titulo.length > 255) {
      this.translate.get('comunicado.novaMensagem.avisoLimiteTitulo').subscribe(text => {
        this.toast.warning(text, 'Atenção');
      });
      return;
    }
    
    if (this.tipoEnvio === null) {
      this.translate.get('comunicado.novaMensagem.avisoTipoEnvio').subscribe(text => {
        this.toast.warning(text, 'Atenção');
      });
      return;
    }
    
    this.enviando = true;
    const form = new FormData();

    const tags = this.marcadores.map(p => p.concat()).toString();

    const contatos = this.contatosSelecionados().map(p => p.id).toString();

    const dealers = this.dealersSelecionados().map(p => p.id).toString();

    form.append('titulo', this.titulo);
    form.append('mensagem', this.mensagem);
    form.append('tipo_envio', this.tipoEnvio.toString());
    form.append('remetente', '1');
    form.append('destinatarios', contatos);
    form.append('dealers', dealers);
    form.append('tags', tags);

    this.uploader.queue.forEach(file => {
      form.append('file', file._file);
    })

    this.service.enviarArquivo(form)
      .then(res => {
        this.enviado = true;
        this.translate.get('comunicado.novaMensagem.comunicadoEnviado').subscribe(text => {
          this.toast.success(text, 'Sucesso');
        });
        
        setTimeout(() => {
          this.cancelarInclusao();
        }, 2000);
      })
      .catch(erro => {
        this.enviando = false;
        this.translate.get('comunicado.erro.erroEnviarComunicado').subscribe(text => {
          this.toast.error(text, this.translate.instant('comunicado.erro.erroInesperado'));
        });
      });
  }

  cancelarInclusao(): void {
    this.ativo = false;
    this.salvado.emit(this.ativo);
    this.marcadores = [];
    this.titulo = '';
    this.mensagem = '';
    this.tipoEnvio = null;
    this.enviando = false;
    this.enviado = false;
    this.uploader.clearQueue();
    this.tamanhoTotalArquivos = 0;
    this.contatos.forEach(contato => contato.selecionado = false);
    this.dealers.forEach(dealer => dealer.selecionado = false);
    this.countDestinatario = 0;
    this.countDealer = 0;
    this.habilitaEnvio = true;
    this.ativaComunicado.emit(true);
  }

  inserirMarcador(event: any): void {
    if (!event.target.value.isEmpty) {
      this.marcadores.push(event.target.value);
      event.target.value = '';
    }
  }

  removerMarcador(marcador): void {
    this.marcadores = this.marcadores.filter(function(value) {
      return value !== marcador;
    });
  }
  
  adicionarDestinatario(destinatario: any): void {
    destinatario.selecionado = true;
    this.countDestinatario += 1; 

    this.verificarHabilitacaoEnvio();
  }

  removerDestinatario(destinatario: any): void {
    destinatario.selecionado = false;
    this.countDestinatario -= 1;

    this.verificarHabilitacaoEnvio();
  }

  adicionarDealer(dealer: any): void {
    dealer.selecionado = true;
    this.countDealer += 1;

    this.verificarHabilitacaoEnvio();
  }

  removerDealer(dealer: any): void {
    dealer.selecionado = false;
    this.countDealer -= 1;

    this.verificarHabilitacaoEnvio();
  }

  adicionarTodosDestinatarios(): void {
    const contatosDisponiveis = this.contatosDisponiveis();
    contatosDisponiveis.forEach(contato => {
      contato.selecionado = true;
      this.countDestinatario += 1;
    });
    this.verificarHabilitacaoEnvio();
  }

  removerTodosDestinatarios(): void {
    const contatosSelecionados = this.contatosSelecionados();
    contatosSelecionados.forEach(contato => {
      contato.selecionado = false;
      this.countDestinatario -= 1;
    });
    this.verificarHabilitacaoEnvio();
  }

  reloadPage(){
    setTimeout(() => {  
      window.location.reload();
    }, 3000);
  }

  selecionarDestinatario(): void {
    this.mostrarModalDestinatarios = true;
  }

  selecionarDealer(): void {
    this.mostrarModalDealers = true;
  }

  fecharModalDealers(): void {
    this.mostrarModalDealers = false;
  }

  removerArquivo(arquivo: any): void {
    const index = this.uploader.queue.indexOf(arquivo);
    if (index > -1) {
      this.uploader.queue.splice(index, 1);
      this.tamanhoTotalArquivos = this.calcularTamanhoTotal();
    }
  }

  verificarHabilitacaoEnvio(): void {
    // O comunicado pode ser enderecado a usuarios, a dealers, ou aos dois.
    // Cada dealer e expandido no backend para os usuarios ativos vinculados.
    const temDestinatarios = this.countDestinatario > 0 || this.countDealer > 0;
    const mensagemValida = this.mensagem.length <= this.maxCaracteres && this.mensagem.trim().length > 0;
    const tituloValido = this.titulo.length <= 255 && this.titulo.trim().length > 0;
    const tipoEnvioValido = this.tipoEnvio !== null;
    
    this.habilitaEnvio = !(temDestinatarios && mensagemValida && tituloValido && tipoEnvioValido);
  }

  onMensagemChange(): void {
    this.verificarHabilitacaoEnvio();
  }

  onTituloChange(): void {
    this.verificarHabilitacaoEnvio();
  }

  onTipoEnvioChange(): void {
    this.verificarHabilitacaoEnvio();
  }

  atualizarOpcoesDropdown(): void {
    this.tipoEnvioOpcoes = [
      { 
        label: this.translate.instant(this.TipoEnvioLabels[TipoEnvio.PORTAL]), 
        value: TipoEnvio.PORTAL, 
        icon: this.TipoEnvioIcons[TipoEnvio.PORTAL] 
      },
      { 
        label: this.translate.instant(this.TipoEnvioLabels[TipoEnvio.EMAIL]), 
        value: TipoEnvio.EMAIL, 
        icon: this.TipoEnvioIcons[TipoEnvio.EMAIL] 
      },
      { 
        label: this.translate.instant(this.TipoEnvioLabels[TipoEnvio.AMBOS]), 
        value: TipoEnvio.AMBOS, 
        icon: this.TipoEnvioIcons[TipoEnvio.AMBOS] 
      }
    ];
  }

  getTipoEnvioLabel(): string {
    if (this.tipoEnvio === null) return '';
    const opcao = this.tipoEnvioOpcoes.find(o => o.value === this.tipoEnvio);
    return opcao ? opcao.label : '';
  }

  fecharModalDestinatarios(): void {
    this.mostrarModalDestinatarios = false;
  }

  onCaracterInvalidoTitulo(caracteres: string): void {
    this.mostrarAvisoAsciiTitulo = true;
    
    setTimeout(() => {
      this.mostrarAvisoAsciiTitulo = false;
    }, 1500);
  }

  onCaracterInvalidoMensagem(caracteres: string): void {
    this.mostrarAvisoAsciiMensagem = true;
    
    setTimeout(() => {
      this.mostrarAvisoAsciiMensagem = false;
    }, 1500);
  }

  private sanitizarNomeArquivo(fileItem: any): void {
    const nomeOriginal = fileItem.file.name;
    const nomeLimpo = this.limparNomeArquivo(nomeOriginal);
    
    if (nomeOriginal !== nomeLimpo) {
      const arquivoLimpo = new File([fileItem._file], nomeLimpo, {
        type: fileItem._file.type,
        lastModified: fileItem._file.lastModified
      });
      
    
      fileItem._file = arquivoLimpo;
      fileItem.file.name = nomeLimpo;
      
      const caracteresInvalidos = this.encontrarCaracteresInvalidos(nomeOriginal);
      if (caracteresInvalidos.length > 0) {
        setTimeout(() => {
          this.translate.get('comunicado.validacao.nomeArquivoAlterado', { 
            original: nomeOriginal, 
            novo: nomeLimpo 
          }).subscribe(mensagem => {
            this.toast.info(mensagem, this.translate.instant('comunicado.validacao.caracteresInvalidos'));
          });
        }, 100);
      }
    }
  }

  private limparNomeArquivo(nomeArquivo: string): string {
    const ultimoPonto = nomeArquivo.lastIndexOf('.');
    let nome = nomeArquivo;
    let extensao = '';
    
    if (ultimoPonto > 0) {
      nome = nomeArquivo.substring(0, ultimoPonto);
      extensao = nomeArquivo.substring(ultimoPonto);
    }
    
    let nomeLimpo = this.substituirCaracteresEspeciais(nome);
    
    nomeLimpo = nomeLimpo.replace(/[^\x00-\x7F]/g, '');
    
    nomeLimpo = nomeLimpo.replace(/\s+/g, '_');
    
    nomeLimpo = nomeLimpo.replace(/[^a-zA-Z0-9_-]/g, '');
    
    if (!nomeLimpo) {
      nomeLimpo = 'arquivo';
    }
    
    return nomeLimpo + extensao;
  }

  private substituirCaracteresEspeciais(texto: string): string {
    let resultado = texto;
    
    for (const [invalido, valido] of Object.entries(this.CARACTERES_INVALIDOS_COMUNS)) {
      resultado = resultado.split(invalido).join(valido);
    }
    
    return resultado;
  }

  private encontrarCaracteresInvalidos(texto: string): string {
    const ASCII_PATTERN = /^[\x00-\x7F]*$/;
    const caracteresUnicos = new Set<string>();
    
    for (const char of texto) {
      if (!ASCII_PATTERN.test(char) || /[^\w\s.-]/i.test(char)) {
        caracteresUnicos.add(char);
      }
    }
    
    return Array.from(caracteresUnicos).join(', ');
  }

  /**
   * Calcula o tamanho total de todos os arquivos na fila
   * @returns Tamanho total em bytes
   */
  calcularTamanhoTotal(): number {
    return this.uploader.queue.reduce((total, item) => {
      return total + (item._file?.size || 0);
    }, 0);
  }

  /**
   * Formata tamanho em bytes para MB com 2 casas decimais
   * @param bytes Tamanho em bytes
   * @returns String formatada (ex: "2.50 MB")
   */
  formatarTamanho(bytes: number): string {
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(2)} MB`;
  }

  /**
   * Retorna o tamanho total formatado para exibição
   */
  getTamanhoTotalFormatado(): string {
    return this.formatarTamanho(this.tamanhoTotalArquivos);
  }

  /**
   * Retorna a porcentagem usada do limite total
   */
  getPorcentagemUsada(): number {
    return (this.tamanhoTotalArquivos / this.TAMANHO_MAX_TOTAL_BYTES) * 100;
  }

  /**
   * Retorna o tamanho disponível restante formatado
   */
  getTamanhoDisponivelFormatado(): string {
    const disponivel = this.TAMANHO_MAX_TOTAL_BYTES - this.tamanhoTotalArquivos;
    return this.formatarTamanho(disponivel > 0 ? disponivel : 0);
  }

}